import { HttpErrorResponse } from '@angular/common/http';
import { isArray } from 'typedash';
import { isHttpErrorResponse } from 'app/core/util/util';

export interface ErrorMessage {
  message: string;
  subMessages: string[];
  errorResponse: HttpErrorResponse;
}

export function isErrorMessage(error: any): error is ErrorMessage {
  return typeof error.message === 'string' && (!error.subMessages || isArray(error.subMessages)) && !error.errorResponse || isHttpErrorResponse(error.errorResponse);
}
